"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InlineHtmlRenderer_1 = require("../../components/InlineHtmlRenderer");
InlineHtmlRenderer_1.InlineHtmlRenderer.each("script[data-class*=inline-content]");
